<template>
  <div class="pw-notifications">
    <transition-group name="notifications">
      <Notification
        v-for="notification in notifications"
        :key="notification.id"
        :type="notification.type"
        :message="notification.message"
        :duration="notification.duration"
        :id="notification.id"
        :title="notification.title"
        @destroyed="onDestroy"
      />
    </transition-group>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Notification from './Notification.vue';

export default {
  name: 'Notifications',
  components: {
    Notification,
  },
  computed: {
    ...mapState('notifications', ['notifications']),
  },
  methods: {
    ...mapActions({
      dropNotification: 'notifications/dropNotification',
    }),
    onDestroy(IDX) {
      this.dropNotification(IDX);
    },
  },
};
</script>

<style lang="scss">
body {
  overflow-x: hidden !important;
}
hr {
  background-color: #d8e3eb;
  border: 0;
  height: 1px;
  margin-top: 0;
}
.pw-notifications {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 316px;
  z-index: 100000;
}
.notifications-enter-active,
.notifications-leave-active {
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.notifications-enter, .notifications-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
</style>
